import { http } from "./httpClient";

export const settingsApi = {
  get: () => http.get("/me/"),
  update: (patch) => http.patch("/me/", patch),
};
